<template>
    <div class="strategy_main" :style="{backgroundColor:getSuccessCourseColor()}">
        <HeaderNav :navtitle="strategyTitle" :beforecolor="'#fff'"
                   :backcolor="getSuccessCourseColor()" :innerPageArticleId="objStrategy.innerPageArticleId"
                   @returnBack="goToBack" @goInsidePages="goInsidePages"/>
        <div></div>
        <!-- 讲解视频 -->
        <div class="video_title">
            <div class="left_line"></div>
            <div class="title_back"><span>本课讲解</span></div>
            <div class="right_line"></div>
        </div>
        <div class='video_content'>
            <video-player class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions">
            </video-player>
        </div>

        <!-- 书上的练习题要这样做 -->
        <div class="video_title mg_top">
            <div class="left_line"></div>
            <div class="title_back"><span>练习指导</span></div>
            <div class="right_line"></div>
        </div>
        <div class="exercise_content">
            <pre>{{objStrategy.practiceInstructionText}}</pre>
        </div>

        <!-- 本课故事结构 -->
        <div class="video_title mg_top">
            <div class="left_line"></div>
            <div class="title_back"><span>本课结构图</span></div>
            <div class="right_line"></div>
        </div>
        <div class="group_img">
            <!-- 放大图片 -->
            <img :src="$qiNiuDomainBase + objStrategy.structurePicture"/>
            <div class="text">长按可以保存图片哦～</div>
        </div>

        <div class="bottom"></div>

    </div>
</template>

<script>
    import { videoPlayer } from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                lessonId: 0,
                strategyTitle: "讲解与练习",
                objStrategy: {},
                showImg: false,
                imgSrc: '',
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                }
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            goInsidePages:function(id){
                this.$router.push({name: 'pageView', query: {url: "https://xiaohuasheng.cn/mtesthome_"+ id +"/come_1"}});
            },
            goHome() {
                this.$router.go(-1);
            },
            clickImg(e) {
                this.showImg = true;
                // 获取当前图片地址
                this.imgSrc = e.currentTarget.src;
            },
            viewImg() {
                this.showImg = false;
            },
            learnFinishClick() {
                let that = this;
                let vFinish = that.objStrategy.finish === 1 ? 0 : 1;
                let url = "success/setFinish/" + that.lessonId + "/" + vFinish;
                this.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        that.objStrategy.finish = vFinish;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
        },
        beforeCreate() {
            let vLessonId = parseInt(this.$route.query.lessonId);
            let url = "success/getReadingStrategy/" + vLessonId;
            let that = this;
            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.objStrategy = response.data;

                let vedioUrl = that.$qiNiuDomainBase + that.objStrategy.video;
                that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/5";
                that.playerOptions.sources[0].src = vedioUrl;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        activated() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    .strategy_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .video_title {
        position: relative;
        display: inline-block;
        font-size: 20px;
        font-weight: bold;
        margin-top: 30px;
        color: white;
        text-align: center;
    }

    .left_line {
        position: absolute;
        width: 40px;
        height: 1px;
        background-color: #f4f4f4;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .title_back {
        width: 150px;
        height: 36px;
        background-color: #fda228;
        -webkit-border-radius: 18px;
        -moz-border-radius: 18px;
        margin-left: 50px;
        margin-right: 50px;
        text-align: center;
    }

    .title_back span {
        font-size: 16px;
        font-weight: bold;
        line-height: 36px;
    }

    .right_line {
        position: absolute;
        width: 40px;
        height: 1px;
        margin-left: 210px;
        background-color: #f4f4f4;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .video_content {
        display: inline-block;
        width: calc(100% - 30px);
        height: auto;
        text-align: center;
        line-height: 100px;
        /*border: 1px solid transparent;*/
        /*border-radius: 4px;*/
        overflow: hidden;
        background: #fff;
        position: relative;
        /*box-shadow: 0 1px 1px rgba(0, 0, 0, .2);*/
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 15px;
    }

    .video_content:hover {
        display: block;
    }

    .exercise_content {
        width: calc(100% - 60px);
        height: auto;
        margin-top: 15px;
        color: white;
        font-size: 16px;
        margin-left: 30px;
        margin-right: 30px;
        text-align: left;
    }

    .exercise_content pre {
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .mg_top {
        margin-top: 60px;
    }

    .group_img {
        width: calc(100% - 30px);
        height: auto;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 15px;
    }

    .group_img img {
        width: 100%;
        height: auto;
    }

    .group_img .text {
        width: 100%;
        font-size: 13px;
        margin-top: 10px;
        color: white;
        text-align: center;
    }

    .bottom {
        height: 150px;
    }

</style>
